import './Text.css';



export function NineteenRules() {
  return (
    <div class="body">
<div class="row" id="GalleryThree">
  <div class="column" >   
<h4>
   
                19 Rules of Typography
                , 2025
               <br/>
Instructional Typography Flip Book inspired by Rob Carter<br/><br/>
                Spiral-bound book.
                </h4>
                </div>
</div>


<div class="row" id="GalleryThree">
        <div class="column">
<img alt="Grim Reynolds" src="19rules18.jpg" />
        </div>
        <div class="column">
<img alt="Grim Reynolds" src="19rules14.jpg" />
        </div>
        
        <div class="column">
<img alt="Grim Reynolds" src="19rules13.jpg" />
        </div>
                                <div class="column">
<img alt="Grim Reynolds" src="19rules3.jpg" />
        </div>

                <div class="column">
<img alt="Grim Reynolds" src="19rules12.jpg" />
        </div>
                <div class="column">
<img alt="Grim Reynolds" src="19rules11.jpg" />
        </div>
                        <div class="column">
<img alt="Grim Reynolds" src="19rules16.jpg" />
        </div>

                <div class="column">
<img alt="Grim Reynolds" src="19rules10.jpg" />
        </div>
                <div class="column">
<img alt="Grim Reynolds" src="19rules9.jpg" />
        </div>
                <div class="column">
<img alt="Grim Reynolds" src="19rules17.jpg" />
        </div>

                <div class="column">
<img alt="Grim Reynolds" src="19rules8.jpg" />
        </div>
                <div class="column">
<img alt="Grim Reynolds" src="19rules7.jpg" />
        </div>
                <div class="column">
<img alt="Grim Reynolds" src="19Rules1.jpg" />
        </div>
                <div class="column">
<img alt="Grim Reynolds" src="19rules6.jpg" />
        </div>
                <div class="column">
<img alt="Grim Reynolds" src="19rules5.jpg" />
        </div>





        </div>       </div>





  );
}
